import { Box, Container, Grid, Typography, Link, IconButton, useTheme } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const theme = useTheme();

  const footerLinks = {
    'About Us': [
      { name: 'Our Mission', path: '/about' },
    ],
    'Services': [
      { name: 'Vehicle Donation', path: '/donate' },
    ],
    'Support': [
      { name: 'FAQ', path: '/faq' },
      { name: 'Contact Us', path: '/contact' },
    ],
  };

  const socialLinks = [
    { Icon: InstagramIcon, path: "https://www.instagram.com/vehiclesforyoungveterans/", name: "Instagram" },
    { Icon: FacebookIcon, path: "https://www.facebook.com/share/16CtnuKErA/?mibextid=wwXIfr", name: "Facebook" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and Description */}
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src="/logo.png"
              alt="VYVeterans Logo"
              sx={{
                height: 60,
                mb: 2,
                filter: 'brightness(0) invert(1)',
              }}
            />
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Vehicles For Young Veterans is dedicated to supporting young veterans through vehicle donations,
              making a difference in their lives and our community.
            </Typography>
            <Box sx={{ mt: 2 }}>
              {socialLinks.map(({ Icon, path, name }) => (
                <IconButton
                  key={name}
                  component="a"
                  href={path}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: 'white',
                    mr: 1,
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                  }}
                >
                  <Icon />
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <Grid item xs={12} sm={6} md={2} key={category}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                {category}
              </Typography>
              {links.map((link) => (
                <Link
                  key={link.name}
                  component={RouterLink}
                  to={link.path}
                  sx={{
                    display: 'block',
                    color: 'white',
                    opacity: 0.8,
                    textDecoration: 'none',
                    mb: 1,
                    '&:hover': {
                      opacity: 1,
                    },
                  }}
                >
                  {link.name}
                </Link>
              ))}
            </Grid>
          ))}
          
          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'white',
                opacity: 0.8,
                mb: 1,
              }}
            >
              1(833) 838-8398
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'white',
                opacity: 0.8,
              }}
            >
              1(833) 838-VFYV
            </Typography>
          </Grid>
        </Grid>

        {/* Legal Info & Copyright */}
        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            mt: 4,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              opacity: 0.9,
              mb: 2,
              maxWidth: '900px',
              mx: 'auto',
              lineHeight: 1.6,
              fontSize: { xs: '0.875rem', sm: '0.9rem' },
              fontStyle: 'italic',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              [theme.breakpoints.down('sm')]: {
                whiteSpace: 'normal',
              }
            }}
          >
            Vehicles For Young Veterans is a registered assumed name of Sky City Group Co., a 501(c)(3) non-profit organization (Tax ID#&nbsp;33-3013356)
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} VYVeterans. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
